import React, { useState } from 'react';
import { ExternalLink, InlineTextButton, Modal, NamedLink } from '../../../components';
import css  from './VineyardReviews.module.css'
import AddReviewForm from './AddReviewForm';

import ellipse from './ellipse.png'
import { ReviewIcon } from '../../../assets';
import { addNewReview } from '../../../services/review';
import ReviewCard from '../../../components/ReviewCard/ReviewCard';

const VineyardReviews = ({
  winery,
  reviews,
  setReviews,
  reviewsLoading,
  setReviewsLoading,
  currentUser
}) => {
  const [limit, setLimit] = useState(6);
  const [open, setOpen] = useState(false);
  const average = (...args) => args.reduce((a, b) => a + b) / args.length;

  const handleAddNewReview = values => {
    const score = average(
      parseInt(values.quality),
      parseInt(values.variety),
      parseInt(values.venueAmbiance),
      parseInt(values.affordable),
      parseInt(values.foodOfferings),
      parseInt(values.customerService)
    );

    const obj = {
      winery: winery?._id,
      user: currentUser?.expresUserId,
      description: values.description,
      quality: parseInt(values.quality),
      variety: parseInt(values.variety),
      venueAmbiance: parseInt(values.venueAmbiance),
      affordable: parseInt(values.affordable),
      foodOfferings: parseInt(values.foodOfferings),
      customerService: parseInt(values.customerService),
      score: score.toFixed(1),
    }
    addNewReview(obj, setReviewsLoading, setReviews, reviews, setOpen);
  }

  return (
    <>
      <div className={css.vineyardReviewsWrapper}>
        <div className={css.VineyardReviewsEllipse}>
          <img src={ellipse} alt="" />
        </div>
        <div className={css.vineyardReviewsContainer}>
          <div>
            <h1>{winery?.name} Reviews</h1>
          </div>
          {reviews.length > 0 ? (
            <div>
              <div className={css.vineyardReviewsCardWrapper}>
                {reviews.sort().slice(0, limit).map((review, index) => (
                  <ReviewCard
                    key={index}
                    review={review}
                  />
                ))}
              </div>
              <div className={css.vineyardReviewsBtns}>
                {reviews && reviews.length > limit ? (
                  <InlineTextButton
                    rootClassName={css.vineyardReviewsLoadMoreBtn}
                    onClick={() => setLimit(prev => prev + 3)}
                  >
                    Load More Reviews
                  </InlineTextButton>
                ) : null}
                <InlineTextButton
                  className={css.vineyardReviewsWriteBtn}
                  onClick={() => setOpen(true)}
                >
                  Write a Review
                </InlineTextButton>
              </div>
            </div>
          ) : (
            <div className={css.noReviewsYetWrapper}>
              <div className={css.reviewIconWrapper}>
                <ReviewIcon />
              </div>
              <h3 className={css.noReviewTitle}>No reviews yet! Would you like to be the first?</h3>
              <div>
                <InlineTextButton
                  style={{margin: "0"}}
                  className={css.vineyardReviewsWriteBtn}
                  onClick={() => setOpen(true)}
                >
                  Write a Review
                </InlineTextButton>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        id="addReview"
        isOpen={open}
        onClose={() => setOpen(false)}
        // usePortal
        onManageDisableScrolling={f => f}
      >
        <div className={css.modelWrapper}>
          {currentUser ? (
            <AddReviewForm
              onSubmit={handleAddNewReview}
              setTosModelOpen={setOpen}
              inProgress={reviewsLoading}
            />
          ) : (
            <div>
              <span style={{marginRight: "5px"}}>Please login to write a review</span>
              <NamedLink name="LoginPage">Login</NamedLink>
            </div>
          )}

        </div>
      </Modal>
    </>
  )
}

export default VineyardReviews
